// Simple Yotpo Points Detection
function initializeYotpoPoints() {
  const pointsDisplayElement = document.querySelector(".yotpo-points-count .yotpo-points-display");
  
  if (!pointsDisplayElement) {
    return;
  }

  // Function to update points display
  function updatePointsDisplay(points) {
    const allPointsDisplays = document.querySelectorAll(".yotpo-points-display");
    
    allPointsDisplays.forEach((element) => {
      element.textContent = points.toString();
    });
  }

  // Function to check if user is logged in
  function isCustomerLoggedIn() {
    if (typeof Shopify !== 'undefined' && Shopify.customer) {
      return true;
    }
    
    const customerEmailMeta = document.querySelector('meta[name="customer-email"]');
    if (customerEmailMeta) {
      return true;
    }
    
    return false;
  }

  // Function to find points in Yotpo elements
  function findPoints() {
    const pointsElements = document.querySelectorAll('.yotpo-point-balance-text-part');
    
    for (let i = 0; i < pointsElements.length; i++) {
      const element = pointsElements[i];
      const text = element.textContent.trim();
      
      if (element.closest('.yotpo-points-count')) {
        continue;
      }
      
      // First, try to find numbers with spaces (like "1 030")
      const spacedNumberMatch = text.match(/(\d+)\s+(\d+)/);
      if (spacedNumberMatch) {
        const fullNumber = parseInt(spacedNumberMatch[1] + spacedNumberMatch[2]);
        return fullNumber;
      }
      
      // Fallback: Look for the largest number in the text to handle cases with multiple numbers
      const allNumbers = text.match(/\d+/g);
      if (allNumbers && allNumbers.length > 0) {
        // Find the largest number (most likely to be the points value)
        const largestNumber = Math.max(...allNumbers.map(num => parseInt(num)));
        return largestNumber;
      }
    }
    
    return null;
  }

  // Function to wait for Yotpo to load and find points
  function waitForPoints() {
    let attempts = 0;
    const maxAttempts = 100;
    
    const checkForPoints = () => {
      attempts++;
      
      const points = findPoints();
      if (points !== null) {
        updatePointsDisplay(points);
        return;
      }
      
      if (attempts >= maxAttempts) {
        updatePointsDisplay(0);
        return;
      }
      
      setTimeout(checkForPoints, 200);
    };
    
    checkForPoints();
  }

  // Initialize points detection
  if (isCustomerLoggedIn()) {
    waitForPoints();
  } else {
    updatePointsDisplay(0);
  }
}

// Try to run immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeYotpoPoints);
} else {
  initializeYotpoPoints();
}

// Fallback timeout to ensure script runs
setTimeout(() => {
  initializeYotpoPoints();
}, 1000);